import React, { useState, useEffect } from 'react';
// import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getUserFromStorage } from '../util/localStorage.util';

const storageInfo = getUserFromStorage();

let permissions = storageInfo?JSON.parse(storageInfo)['permissions']: '';

function getPermission(permission: any, data: any) {
  return permission
    ? permission.includes(data)
    : false;
}

const CheckPermission = ({
  children,
  has,
}: {
 children: any,
 has: string,
}) => {
  const [userPermission, setPermission] = useState<any>(null);
  const [hasPermission, setHasPermission] = useState(null);

  useEffect(() => {
    if (permissions !== userPermission) {
      setPermission(permissions);
      getPermission(permissions, has);
      setHasPermission(getPermission(permissions, has));
    }
  }, [has, userPermission, permissions]);

  if (hasPermission) {
    return children;
  }
  let page=false;
  // 403 forbidden page
  if (page) {
    return <Redirect to='/' />;
  }

  // Component
  return '';
};

export default CheckPermission;
